import { render, staticRenderFns } from "./groupH.vue?vue&type=template&id=56beb498&scoped=true"
import script from "./groupH.vue?vue&type=script&lang=js"
export * from "./groupH.vue?vue&type=script&lang=js"
import style0 from "./groupH.vue?vue&type=style&index=0&id=56beb498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56beb498",
  null
  
)

export default component.exports